import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../lib/http.js';
import { INVITADOS_STATS_KEY } from './useInvitados.js';

async function fetchStats() {
  return apiGet('/api/invitados/stats');
}

// Hook for the admin stats cards. Polls every 30s so the counts stay
// fresh without a full page refresh. staleTime matches the refetch
// interval so we don't re-fetch on every focus event.
export function useStats() {
  return useQuery({
    queryKey: INVITADOS_STATS_KEY,
    queryFn: fetchStats,
    refetchInterval: 30_000,
    staleTime: 30_000,
  });
}